import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import ConversationBody from "components/ConversationComponents/ConversationBody";

const ConversationPage = () => {
  useEffect(() => {
    document.title = "Conversation";
  }, []);

  return (
    <main id="app">
      <Header moduleName="conversation" />
      <ConversationBody />
    </main>
  );
};

export default ConversationPage;
